import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "toc-title" }
const _hoisted_2 = ["onClick"]

import { ref, onMounted, onUnmounted, PropType, watch } from 'vue'
import { marked } from 'marked'
import xss from 'xss'

interface TocItem {
  title: string
  slug: string
  level: 1 | 2 | 3 | 4 | 5 | 6
}


export default /*#__PURE__*/_defineComponent({
  props: {
  content: String as PropType<string>,
  showToc: {
    required: false,
    type: Boolean as PropType<boolean>,
    default: false,
  },
  gutter: {
    required: false,
    type: Number,
    default: 40,
  },
},
  setup(__props) {

const props = __props

/* eslint-disable @typescript-eslint/ban-ts-comment */
const containerEle = ref()



const renderer = new marked.Renderer()
const toc = ref<TocItem[]>([]) // your table of contents as a list.

const scrollView = (id: string) => {
  const ele = containerEle.value
  if (ele) {
    const target = document.getElementById(id)
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
      })
    }
  }
}

if (props.showToc) {
  renderer.heading = function (text, level) {
    const slug = text.toLowerCase().replace(/[^\w]+/g, '-')
    if (level > 1) {
      toc.value.push({ level, slug, title: text })
    }
    return `<h${level} id="${slug}">${text}</h${level}>`
  }
}
renderer.link = function (href, title, text) {
  if (href?.startsWith('http')) {
    return `<a href="${href}" target="_blank" rel="noopener noreferrer">${text}</a>`
  }
  // @ts-ignore-line
  // Temp Fix: Dynamically add scroll events to links after conversion to html
  window.scrollView = scrollView
  const id = href?.replace('#', '')
  return `<a onclick="scrollView('${id}')">${text}</a>`
}

const convertMarkdown = function (text: string) {
  return marked(text, {
    renderer,
  })
}

const setEle = (val: string | undefined) => {
  if (!val) {
    containerEle.value.innerHTML = ''
  } else {
    containerEle.value.innerHTML = xss(convertMarkdown(val))
  }
}

onMounted(() => {
  setEle(props.content)
})

onUnmounted(() => {
  // @ts-ignore-line
  window.scrollView = undefined
})

watch(() => props.content, setEle)

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createBlock(_component_el_row, {
    class: "markdown-content",
    gutter: __props.gutter
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_col, {
        span: __props.showToc ? 18 : 24
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "markdown-content",
            ref_key: "containerEle",
            ref: containerEle
          }, null, 512)
        ]),
        _: 1
      }, 8, ["span"]),
      (__props.showToc)
        ? (_openBlock(), _createBlock(_component_el_col, {
            key: 0,
            class: "toc-list",
            span: 6
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('Base.content')), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(toc.value, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item.slug,
                  class: _normalizeClass(['toc', `level-${item.level}`])
                }, [
                  _createElementVNode("a", {
                    class: "toc-item",
                    onClick: ($event: any) => (scrollView(item.slug))
                  }, _toDisplayString(item.title), 9, _hoisted_2)
                ], 2))
              }), 128))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["gutter"]))
}
}

})